'use client';

import { Flex, Skeleton, SkeletonCircle, SkeletonText } from '@chakra-ui/react';

const PersonSkeleton = () => {
  return (
    <Flex flexDir={'column'} rowGap={'18px'}>
      <Flex alignItems={'center'} columnGap={'24px'}>
        <Skeleton h={'68px'} w={'68px'} borderRadius={'4px'} />
        <Skeleton h={'34px'} w={'260px'} borderRadius={'4px'} />
      </Flex>
      <Skeleton w={'250px'} h={'36px'} borderRadius={'4px'} />
      <Flex alignItems={'center'} columnGap={'12px'}>
        {Array.from(Array(2).keys()).map((skn) => (
          <SkeletonCircle w={'30px'} h={'30px'} key={'person' + skn} />
          // key={useOutsideClick}
        ))}
      </Flex>
      <Skeleton w={'160px'} h={'36px'} borderRadius={'4px'} />
      <Flex flexDir={'column'} rowGap={'64px'} pt={'40px'}>
        <Skeleton
          w={'100%'}
          minH={'160px'}
          bg={'#7E869E11'}
          borderRadius={'10px'}
          {...{ isLoaded: true }}
          pt={'20px'}
        >
          <Skeleton w={'220px'} h={'24px'} />
          <Flex
            flexDir={'column'}
            rowGap={'12px'}
            w={'100%'}
            h={'100%'}
            p={'20px'}
          >
            <Flex
              alignItems={'center'}
              justifyContent={'space-between'}
              columnGap={'6px'}
            >
              {Array.from(Array(7).keys()).map((skl) => (
                <Skeleton w={'100%'} h={'24px'} key={'person' + skl} />
              ))}
            </Flex>
            <Skeleton
              startColor={'borderGray'}
              endColor={'grey'}
              w={'100%'}
              h={'1px'}
            />
            <SkeletonText w={'100%'} />
          </Flex>
        </Skeleton>
        <Skeleton
          w={'100%'}
          minH={'140px'}
          bg={'#7E869E11'}
          borderRadius={'10px'}
          {...{ isLoaded: true }}
        >
          <Flex
            alignItems={'center'}
            columnGap={'24px'}
            w={'100%'}
            h={'100%'}
            p={'20px'}
          >
            <SkeletonText w={'60%'} />
            <Skeleton w={'120px'} h={'46px'} />
          </Flex>
        </Skeleton>
      </Flex>
      <Flex alignItems={'center'} justifyContent={'center'}>
        <Skeleton w={'60%'} h={'16px'} mt={'24px'} />
      </Flex>
    </Flex>
  );
};

export default PersonSkeleton;
